export enum PlaceholderElementType {
  Video = 'Video',
  SlideShow = 'SlideShow',
}
